<template>
  <div class="receive-free-page" :style="{background: bgColor}">
    <div class="head">
      <img v-if="headImg" :src="headImg">
    </div>
    <div class="center">
      <div
        class="swiper-container"
        :style="{backgroundImage: 'url(' + circle + ')', backgroundRepeat: 'no-repeat', backgroundPosition: '50% 106%', backgroundSize: '75% 35%'}"
      >
        <div v-if="rewardImages && rewardImages.length" class="swiper-wrapper">
          <div v-for="(item, index) of rewardImages" :key="index" class="swiper-slide card">
            <div class="mask" :style="{background: bgColor}"></div>
            <img :src="item">
          </div>
        </div>
      </div>
      <div
        v-if="gotVip"
        :style="{background: bottonBgColor, color: bottonWordsColor}"
        class="receive-btn"
        @click="useVip"
      >{{getBtnTxt || "已领取"}}</div>
      <div
        v-else
        :style="{background: bottonBgColor, color: bottonWordsColor}"
        class="receive-btn"
        @click="getVip"
      >{{bottonWords}}</div>
      <div v-if="!gotVip" :style="{color: underColor}" class="btn-tip">{{underWords}}</div>
    </div>
    <div
      v-if="rules && rules.length"
      class="rules"
      :style="{background: ruleBgColor, color: ruleColor}"
    >
      <div class="rule-title">领取规则</div>
      <div class="rule-item fx-row fx-c-start" v-for="(item, index) of rules" :key="index">
        <div class="rule-index">{{index + 1 +'.'}}</div>
        <div>{{item}}</div>
      </div>
    </div>
    <popup
      :showPopup="showPopup"
      :popupConfigCode="popupConfigCode"
      :defPopupConfig="popupConfig"
      @close-popup="closePopup"
      @use-vip="useVip"
    ></popup>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { handleException } from "@/request/helpers.js";
import auth from "@/request/auth.js";
import { get } from "@/utils";
import env from "@/utils/env";
import nativeApi from "@/utils/native-api";
import localStorage from "@/utils/localStorage";
import ga from "@/utils/tracker.js";
import weixinApi from "@/utils/weixinApi";

import Popup from "./components/popup";
import downloadApp from '../../Helper/download-app.js';

const Swiper = require("@/utils/swiper.js").Swiper;
let mySwiper = null;

const BtnTxt = {
  0: "使用会员权益",
  1: "续费",
  2: "使用会员权益"
};

const touchmoveHandler = function(e) {
  e.preventDefault();
};

export default {
  data() {
    return {
      gotVip: false,
      getBtnTxt: "",
      showPopup: false,
      popupConfigCode: -1,
      popupConfig: null
    };
  },
  components: {
    Popup
  },
  computed: {
    ...mapState("vipCard/receiveFree", [
      "headImg",
      "rewardImages",
      "bgColor",
      "shareConfig",

      "rules",
      "ruleBgColor",
      "ruleColor",

      "bottonBgColor",
      "bottonWords",
      "bottonWordsColor",

      "underWords",
      "underColor",

      "circle"
    ])
  },
  created() {
    let { actid } = this.$route.query;
    if (actid) {
      this.SET_ACTID(actid);
    }

    let isSendingVip = localStorage.get("receiveFree.loginCallback");
    if (!isSendingVip) {
      this.initData();
    } else {
      localStorage.remove("receiveFree.loginCallback");
      this.sendRequest();
    }
  },
  updated() {
    this.initSwiper();
    this.initShare();
  },
  methods: {
    ...mapActions("vipCard/receiveFree", ["queryConfigById", "sendGoldMember"]),
    ...mapMutations("vipCard/receiveFree", ["SET_ACTID"]),

    initData() {
      this.queryConfigById().catch(err => {
        handleException.call(this, err, true);
      });
    },

    initSwiper() {
      if (mySwiper) {
        mySwiper.destroy();
      }

      if (this.rewardImages && this.rewardImages.length) {
        let _this = this;

        mySwiper = new Swiper(".swiper-container", {
          slidesPerView: "auto",
          touchRatio: 0.5, //触摸变慢
          followFinger: false,
          loop: true,
          effect: "coverflow",
          centeredSlides: true,
          autoplay: {
            delay: 2000,
            stopOnLastSlide: false,
            disableOnInteraction: false
          },
          coverflowEffect: {
            rotate: 0,
            stretch: 38,
            depth: 120,
            modifier: 2
          },
          on: {
            slideChange: function() {
              setTimeout(() => {
                _this.updateCardsBg(
                  this.slides,
                  this.params.coverflowEffect.modifier
                );
              }, 0);
            }
          }
        });
      }
    },

    updateCardsBg(slides, modifier) {
      for (let i in slides) {
        let zIndex = slides[i].style && slides[i].style.zIndex;
        if (zIndex || zIndex == 0) {
          slides[i].style.opacity = 1;
          if (zIndex == 1) {
            slides[i].firstChild.className = "mask";
          } else if (zIndex == 1 - modifier) {
            slides[i].firstChild.className = "mask shadow-level1";
          } else if (zIndex == 1 - modifier * 2) {
            slides[i].firstChild.className = "mask shadow-level2";
          } else {
            slides[i].style.opacity = 0;
            slides[i].firstChild.className = "mask shadow-level3";
          }
        }
      }
    },

    initShare() {
      // 配置分享
      if (this.shareConfig) {
        let ptid = localStorage.get("ptid") || "";
        let shareParams = Object.assign({}, this.shareConfig, {
          link: `https://h5.133.cn/gtgjwap/h5/vipCard/receiveFree${
            ptid ? "?ptid=" + ptid : ""
          }`,
          type: "weixin,pengyouquan"
        });
        if (env.isNative) {
          nativeApi.invoke("updateHeaderRightBtn", {
            action: "show",
            text: "分享"
          });

          nativeApi.actions.headerRightBtnClick = function() {
            nativeApi.invoke("sharePage", shareParams);
            ga.track("vipCard/receiveFree", "sharePage", "fromClient");
          };
        } else if (env.isWeixin) {
          weixinApi.share(
            Object.assign({}, shareParams, {
              success() {
                ga.track("vipCard/receiveFree", "sharePage", "fromWechat");
              }
            })
          );
        }
      }
    },

    getVip() {
      auth
        .ensure({
          method: "replace",
          callback: this.loginCallback
        })
        .then(() => {
          this.sendRequest();
        })
        .catch(err => {
          handleException.call(this, err, true, this.loginCallback);
        });
    },

    // 在客户端内跳转去会员卡页面,在客户端外跳转去下载页
    useVip() {
      if (env.isNative) {
        location.href =
          "gtgj://start?type=weex&project_name=gtgj&hlo_module=gtgj&product_module=Membership&hlo_path=home";
      } else {
        downloadApp();
      }
    },

    loginCallback() {
      localStorage.set("receiveFree.loginCallback", true);
    },

    sendRequest() {
      return this.sendGoldMember()
        .then(r => {
          if (r && (r.code == 0 || r.code == 1 || r.code == 2)) {
            this.gotVip = true;
            this.getBtnTxt = BtnTxt[Number(r.code)];
            this.popupConfigCode = Number(r.code);
            this.toShowPopup();
          }
        })
        .catch(err => {
          // handleException.call(this, err, true, this.sendGoldMember);
          let desc =
            typeof err === "string"
              ? err
              : get(err, "message") ||
                get(err, "data.res.hd.desc") ||
                "领取失败，请稍后再试。";
          this.popupConfig = {
            title: "管家提示",
            desc: [].concat(desc),
            icon: "notice"
          };
          this.toShowPopup();
        });
    },
    toShowPopup() {
      this.showPopup = true;
      let appView = document.getElementById("app");
      appView.addEventListener("touchmove", touchmoveHandler);
    },
    closePopup() {
      this.showPopup = false;
      let appView = document.getElementById("app");
      appView.removeEventListener("touchmove", touchmoveHandler);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../scss/_vars.scss";
@import "../../../../scss/swiper.css";

.receive-free-page {
  padding-bottom: 30 * $px;
  .head {
    min-height: 202 * $px;
    img {
      width: 100%;
    }
  }
  .center {
    .swiper-container {
      min-height: 159 * $px;
      margin-top: 8 * $px;
      .swiper-slide {
        width: 40%;
        position: relative;
      }
      .card {
        img {
          width: 100%;
        }
      }
      .mask {
        position: absolute;
        top: 5.5%;
        left: 10%;
        right: 10%;
        bottom: 12.5%;
        border-radius: 4 * $px;
        opacity: 0;
        &.shadow-level1 {
          opacity: 0.2999;
        }
        &.shadow-level2 {
          opacity: 0.7491;
        }
        // &.shadow-level3 {
        //   opacity: 1;
        //   top: 0;
        //   left: 0;
        //   right: 0;
        //   bottom: 0;
        // }
      }
    }
    .receive-btn {
      width: 225 * $px;
      height: 42 * $px;
      border-radius: 21 * $px;
      font-size: 16 * $px;
      font-weight: 600;
      line-height: 42 * $px;
      text-align: center;
      margin: 0 auto;
    }
    .btn-tip {
      font-size: 13 * $px;
      font-weight: 500;
      text-align: center;
      margin-top: 12 * $px;
    }
  }
  .rules {
    margin: 24 * $px 14 * $px 0;
    border-radius: 4 * $px;
    padding: 16 * $px 12 * $px 24 * $px;
    .rule-title {
      font-size: 15 * $px;
      font-weight: 500;
      text-align: center;
      margin-bottom: 8 * $px;
    }
    .rule-item {
      font-size: 13 * $px;
      font-weight: 500;
      line-height: 18 * $px;
      margin-top: 4 * $px;
      .rule-index {
        margin-right: 4 * $px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/projects/vipCard/pages/receiveFree/index.vue